import React, { useState, useCallback } from "react";
import { 
  SuccessMessage,
  FailMessage,
  Loading,
  FormatValueToDecimal,
  CompanySelect,
  FormatDateToMDY,
  DateSelect,
  CustomerSelect,
  FormatDateToWord
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import { PDFDocument } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import NoAccess from "../NoAccess";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

export default function StatementOfAccount() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
//#endregion






//#region Variables 
  const [customer, setCustomer] = useState(null);
  const [company, setCompany] = useState(null);
  const today = new Date().toISOString().split("T")[0];
  const [dateFrom, setDateFrom] = useState(today);
  const [dateTo, setDateTo] = useState(today);
  const [showCustomerSelect, setShowCustomerSelect] = useState(false);
  
  const openCustomerSelect = () => {
    setShowCustomerSelect(true)
  }
  const closeCustomerSelect = () => {
    setShowCustomerSelect(false)
  }
//#endregion






//#region Generate
  const fetchReportData = useCallback(async (_data) => {
    const body = {
      customerId: _data.customerId,
      dateFrom: dateFrom,
      dateTo: dateTo,
    }

    try {
      // const response = await axios.post(`${apiUrl}/api/Report/report-data/statement-of-account`, body, {
      const response = await axios.post(`${apiUrl}/api/Report/report-data/statement-of-account`, body, {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, [dateFrom, dateTo]);

  const generateHandleClick = async () => {
    if (!dateFrom || !dateTo || !company || !customer) {
        setFailMessage("Please fill up required fields");
        return;
    }

    setLoading(true);
    const _data = await fetchReportData(customer);

    if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
    }

    try {
        const pdfUrl = `${window.location.origin}/docs/STATEMENT_OF_ACCOUNT_NEW.pdf`;
        const response = await fetch(pdfUrl);
        const pdfBytes = await response.arrayBuffer();
        const pdfDoc = await PDFDocument.load(pdfBytes);

        pdfDoc.registerFontkit(fontkit);
        const fontResponse = await fetch("/calibri.ttf");
        const fontBytes = await fontResponse.arrayBuffer();
        const calibriFont = await pdfDoc.embedFont(fontBytes);

        const boldResponse = await fetch("/calibrib.ttf");
        const boldBytes = await boldResponse.arrayBuffer();
        const calibriBold = await pdfDoc.embedFont(boldBytes);

        const wrapText = (text, maxWidth, font, fontSize) => {
            if (!text) return [""];
            const words = text.split(" ");
            const lines = [];
            let currentLine = '';
            for (const word of words) {
                const testLine = currentLine ? `${currentLine} ${word}` : word;
                if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
                    currentLine = testLine;
                } else {
                    if (currentLine) lines.push(currentLine);
                    currentLine = word;
                }
            }
            if (currentLine) lines.push(currentLine);
            return lines;
        };

        const drawHeader = (targetPage) => {
            targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 741, size: 16, font: calibriBold });
            targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 731, size: 8, font: calibriFont });
            targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 721, size: 8, font: calibriFont });
            
            targetPage.drawText(customer.name1 ?? "", { x: 35, y: 580, size: 11, font: calibriBold });
            targetPage.drawText(FormatDateToWord(new Date()), { x: 500, y: 580, size: 11, font: calibriBold });
            targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 275, y: 635, size: 10, font: calibriBold });
        };

        let currentPage = pdfDoc.getPages()[0];
        drawHeader(currentPage);

        let yPosition = 540;
        const bottomThreshold = 80;
        const colWidthDesc = 180; 
        const lineHeight = 12;

        let grandTotalAmount = 0;
        let paymentAmount = 0;
        let balance = 0;

        for (const record of _data) {
            for (const item of record.items) {
                if (yPosition < bottomThreshold) {
                    currentPage = pdfDoc.addPage([currentPage.getWidth(), currentPage.getHeight()]);
                    drawHeader(currentPage);
                    yPosition = 540;
                }

                // Draw Date
                currentPage.drawText(FormatDateToMDY(record.date), { x: 35, y: yPosition, size: 8, font: calibriFont });

                const qtyVal = parseFloat(item.quantity) || 0;

                const descLines = wrapText(item.itemDescription, colWidthDesc, calibriFont, 8);
                
                currentPage.drawText(`${FormatValueToDecimal(qtyVal)} ${item.uomName}`, { x: 90, y: yPosition, size: 8, font: calibriFont });
                
                // FIXED: Replaced .forEach with a standard for loop to avoid linting error
                for (let i = 0; i < descLines.length; i++) {
                    currentPage.drawText(descLines[i], { 
                        x: 140, 
                        y: yPosition - (i * lineHeight), 
                        size: 8, 
                        font: calibriFont 
                    });
                }

                currentPage.drawText(FormatValueToDecimal(item.unitPrice), { x: 260, y: yPosition, size: 8, font: calibriFont });
                currentPage.drawText(FormatValueToDecimal(item.subtotal), { x: 340, y: yPosition, size: 8, font: calibriFont });

                const rowHeight = Math.max(lineHeight, descLines.length * lineHeight);
                yPosition -= (rowHeight + 5);
            }

            grandTotalAmount += record.amount;
            paymentAmount += record.payment;
            balance += record.balance;
        }

        // FOOTER SECTION
        if (yPosition < 150) {
            currentPage = pdfDoc.addPage([currentPage.getWidth(), currentPage.getHeight()]);
            yPosition = 540;
            drawHeader(currentPage);
        }

        currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 570, y: yPosition }, thickness: 1 });
        
        yPosition -= 15;
        currentPage.drawText(`Total  `, { x: 260, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(FormatValueToDecimal(grandTotalAmount), { x: 420, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`Payment Amount  `, { x: 260, y: yPosition - 10, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(paymentAmount)}`, { x: 420, y: yPosition - 10, size: 8, font: calibriBold });
        currentPage.drawText(`Balance  `, { x: 260, y: yPosition - 20, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(balance)}`, { x: 505, y: yPosition - 20, size: 8, font: calibriBold });

        // Signatures
        const sigY = yPosition - 60;
        const sigWidth = 120;
        
        // Helper drawn once outside loops is safe
        const drawSignatureLine = (x, label) => {
            currentPage.drawLine({ start: { x, y: sigY }, end: { x: x + sigWidth, y: sigY }, thickness: 1 });
            currentPage.drawText(label, { x: x + 30, y: sigY - 12, size: 8, font: calibriBold });
        };

        drawSignatureLine(35, "Prepared by");
        drawSignatureLine(235, "Approved by");
        drawSignatureLine(435, "Received by");

        const modifiedPdfBytes = await pdfDoc.save();
        const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = `SOA_${customer.name1}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } catch (error) {
        console.error("Error:", error);
        setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };
//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasStatementOfAccount) {
    return <NoAccess />;
  }
//#endregion






//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <HistoryEduIcon fontSize="large" className="text-theme-color" />
              {`Statement of Account`}
            </h2>
            <p className="text-gray-500 mt-1">Summary of all transactions.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Customer <span className="text-red-500">*</span>
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Customer"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                readOnly
              />
              {!customer ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelect}>
                  <PersonSearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setCustomer(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Company <span className="text-red-500">*</span>
            </label>
            <CompanySelect data={company} setData={setCompany} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date From <span className="text-red-500">*</span>
            </label>
            <DateSelect data={dateFrom} setData={setDateFrom} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date To <span className="text-red-500">*</span>
            </label>
            <DateSelect data={dateTo} setData={setDateTo} isEditable={true}/>
          </div>
        </div>

        <button onClick={generateHandleClick} className="mt-10 flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
          <RestartAltIcon fontSize="small" /> Generate
        </button>
      </div>

      <CustomerSelect 
        visible={showCustomerSelect} 
        onClose={closeCustomerSelect}
        modalName={"Select Customer"}
        data={customer} setData={setCustomer}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}